/**
 *
 * @param {*} obj object to clean
 * @returns object without null / undefined / ""
 */
export default function cleanObject(obj) {
  const newObject = obj;
  const objectEntries = Object.keys(newObject);
  objectEntries.forEach((item) => {
    if (
      newObject[item] === null ||
      Number.isNaN(newObject[item]) ||
      newObject[item] === undefined ||
      newObject[item] === ""
    ) {
      delete newObject[item];
    }
  });
  return newObject;
}
